import { render, staticRenderFns } from "./QualityControl.vue?vue&type=template&id=1b38a472&scoped=true&"
import script from "./QualityControl.vue?vue&type=script&lang=js&"
export * from "./QualityControl.vue?vue&type=script&lang=js&"
import style0 from "./QualityControl.vue?vue&type=style&index=0&id=1b38a472&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b38a472",
  null
  
)

export default component.exports